/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Grid, Typography, Button, Alert } from "@mui/material";
import profileImage from "../../Components/assets/images/profilePicture.png";
import UserGroupTable from "./UserGroupTable";
import { toast } from "react-toastify";
import { User_Detail, ImageBase, BaseUrl } from "../../services/Url";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Loader } from "../../Components/Loader";
import { enableUSer } from "../../services/Service";
import moment from "moment";

const UserDetail = (props) => {
  const [singleData, setSingleData] = useState();
  const [isloading, setIsloading] = useState(true);
  const navigate = useNavigate();
  const params = useParams();

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const singleDetail = async () => {
    let token = localStorage.getItem("token");
    let CompleteUrl = BaseUrl + User_Detail + `/${params.id}`;
    await fetch(CompleteUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    })
      .then(async (res) => {
        const responseData = await res.json();
        setIsloading(false);
        await delay(1000);
        if (responseData.response !== 200) {
          setSingleData(responseData.data);
          let dd = Object.keys(responseData.data).length;
          if (dd > 0) {
            // toast.success(responseData.response);
          }
        } else return;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    setTimeout(() => {
      singleDetail();
    }, 1500);
  }, []);


 

  return (
    <Box
      display="flex"
      className="box-wrapper br-24 table_bx"
      flexDirection="column"
      justifyContent="flex-start"
    >
      {isloading ? <Loader /> : ""}
      <div className="heading-btn_wrapper">
        <h5
          style={{ display: "inline-flex", cursor: "pointer" }}
          className="fz-20 fw-bold"
          onClick={() => navigate("/users")}
        >
          <span style={{ display: "inline-flex", alignItems: "center" }}>
            <ArrowBackIosIcon />
          </span>{" "}
          User Detail
        </h5>
        <Button
          className="btn btn-design"
          disabled={singleData?.user?.status === false ? true : false }
          onClick={() => navigate(`/edituser/${params?.id}`)}
        >
          Edit User
        </Button>
      </div>
      {
        singleData?.user?.status === true ?
        '' :
        <Alert severity="warning" className="mb-3">This Particular User Account is blocked</Alert>
      }
      <Box className="form_wrapper input_diabled">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box className="prfl_img">
              <img
                src={
                  !singleData?.user?.profile_picture
                    ? profileImage
                    : ImageBase + singleData?.user?.profile_picture
                }
                alt="User Image"
              />
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">First Name</Typography>
              <Typography className="text_bx">
                {singleData?.user?.first_name
                  ? singleData?.user?.first_name
                  : ""}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">Last Name</Typography>
              <Typography className="text_bx">
                {singleData?.user?.last_name ? singleData?.user?.last_name : ""}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">Username</Typography>
              <Typography className="text_bx">
                {singleData?.user?.username ? singleData?.user?.username : ""}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">Email</Typography>
              <Typography className="text_bx">
                {singleData?.user?.email ? singleData?.user?.email : ""}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">Date of Birth</Typography>
              <Typography className="text_bx">
                {singleData?.user?.dob ? singleData?.user?.dob : ""}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">Phone Number</Typography>
              <Typography className="text_bx">
                {singleData?.user?.phone_number
                  ? singleData?.user?.phone_number
                  : ""}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">Address</Typography>
              <Typography className="text_bx">
                {singleData?.user?.address ? singleData?.user?.address : ""}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">City</Typography>
              <Typography className="text_bx">
                {singleData?.user?.city ? singleData?.user?.city : ""}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">Postcode</Typography>
              <Typography className="text_bx">
                {singleData?.user?.postcode ? singleData?.user?.postcode : ""}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">Country</Typography>
              <Typography className="text_bx">
                {singleData?.user?.country ? singleData?.user?.country : ""}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">User Registered Date</Typography>
              <Typography className="text_bx">
                {singleData?.user?.createdAt ? moment(singleData?.user?.createdAt).format("DD-MM-YYYY") : "Not Specified Yet"}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">Total Group Created</Typography>
              <Typography className="text_bx">
                {singleData?.total_group_created
                  ? singleData?.total_group_created
                  : "0"}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">Total Groups Participated</Typography>
              <Typography className="text_bx">
                {singleData?.total_group_participated
                  ? singleData?.total_group_participated
                  : "0"}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">Member Type</Typography>
              <Typography className="text_bx">
                {singleData?.user?.member_type
                  ? singleData?.user?.member_type
                  : "N/A"}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">Membership Purchased Date</Typography>
              <Typography className="text_bx">
                {!singleData?.user?.membership_purchased_date
                  ? "Not Purchased Yet"
                  : singleData?.user?.membership_purchased_date}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ mt: 6 }}>
        <UserGroupTable />
      </Box>
    </Box>
  );
};
export default UserDetail;
